import {
  mobileReg, idCardReg, numAndLetterReg, numAndSymbolReg,
} from '@/constant/regExp';

const validatePhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入手机号'));
  } else if (!mobileReg.test(value)) {
    callback(new Error('手机号格式不正确'));
  } else {
    callback();
  }
};
const validateIdCard = (rule, value, callback) => {
  if (value && !idCardReg.test(value)) {
    callback(new Error('身份证号格式不正确'));
  } else {
    callback();
  }
};
const validateCode = (rule, value, callback) => {
  if (value && !/^[a-z_A-Z0-9-.!@#$%\\^&*)(+={}[\]/",'<>~·`?:;|]+$/.test(value)) {
    callback(new Error('货主编码格式不正确'));
  } else {
    callback();
  }
};
const validateTaxpayerNo = (rule, value, callback) => {
  if (value && !numAndLetterReg.test(value)) {
    callback(new Error('纳税人识别号格式不正确'));
  } else {
    callback();
  }
};
const validateInvoiceTelPhone = (rule, value, callback) => {
  if (value && !numAndSymbolReg.test(value)) {
    callback(new Error('电话号码格式不正确'));
  } else {
    callback();
  }
};
const validateAccount = (rule, value, callback) => {
  if (value && !numAndLetterReg.test(value)) {
    callback(new Error('银行账号格式不正确'));
  } else {
    callback();
  }
};

export const RULES = {
  contacts: [
    { required: true, message: '请输入姓名', trigger: 'blur' },
  ],
  customerCode: [
    { validator: validateCode, trigger: 'blur' },
  ],
  telPhone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { validator: validatePhone, trigger: 'blur' },
  ],
  identityNo: [
    { validator: validateIdCard, trigger: 'blur' },
  ],
  corpName: [
    { required: true, message: '请输入企业名称', trigger: 'blur' },
  ],
  provinces: [
    { required: true, message: '请选择联系人地址', trigger: 'change' },
  ],
  address: [
    { required: true, message: ' ', trigger: 'blur' },
  ],
  taxpayerNo: [
    { validator: validateTaxpayerNo, trigger: 'blur' },
  ],
  invoiceTelPhone: [
    { validator: validateInvoiceTelPhone, trigger: 'blur' },
  ],
  account: [
    { validator: validateAccount, trigger: 'blur' },
  ],
  uniformCreditCode: [
    { required: true, message: '请选择或输入社会信用代码', trigger: 'blur' },
  ],
  industryTypeCode: [
    { required: true, message: '请选择客户行业类型', trigger: 'change' },
  ],
  ext: {
    productCode: [
      { required: true, message: '请选择产品', trigger: 'change' },
    ],
  },
};

export const LEVELTABLECOLUMN = [{
  label: '货主编码',
  prop: 'code',
  width: 180,
  formatter: (row) => row.ext?.customerCode || '--',
},
{
  label: '货主名称',
  prop: 'name',
  width: 180,
},
{
  label: '联系人信息',
  prop: 'info',
  width: 180,
  formatter: (row) => `${row.customerInfo?.contacts || ''} ${row.customerInfo?.telPhone || ''}`,
},
{
  label: '联系地址',
  prop: 'address',
  width: 220,
  formatter: (row) => `${row.customerInfo?.provinceName || ''}${row.customerInfo?.cityName || ''}${row.customerInfo?.countyName || ''}${row.customerInfo?.address || ''}`,
},
{
  label: '操作',
  prop: 'action',
  width: 180,
},
];
export const CHOOSELEVELTABLE = [
  {
    label: '货主名称',
    prop: 'name',
  }, {
    label: '货主编码',
    prop: 'code',
    formatter: (row) => row.ext?.customerCode || '--',
  },
  {
    label: '联系人信息',
    prop: 'info',
    formatter: (row) => `${row.customerInfo?.contacts || ''} ${row.customerInfo?.telPhone || ''}`,
  },
];

export const SHIPPERSTATUS = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '启用',
    value: 'ENABLED',
  },
  {
    label: '禁用',
    value: 'DISABLED',
  },
];

export const STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};

export const BINDTYPE = {
  NONE: 'NONE',
  PARENT: 'PARENT',
  CHILDREN: 'CHILDREN',
};

export const CUSTOMERTYPE = {
  enterprise: '企业',
  personal: '个人',
};

export const TYPE = 'ORG';

export const customerEnableStatus = [0, 1, 2, 3, 4];

export const contractType = {
  negotiable: 'NEGOTIABLE', // 议价合同
  nonnegotiable: 'NONNEGOTIABLE', // 非议价合同
};

// 计费策略场景
export const pricingScene = {
  pay: 'PAY', // 应付
  income: 'INCOME', // 应收
};

// 数据字典类型
export const dictionaryType = {
  industryType: 'industryType',
  crmProductRange: 'crmProductRange',
};

export const TRACK_LIST = [
  { value: '10', label: '工贸赛道' },
  { value: '20', label: '餐零赛道' },
  { value: '30', label: '农牧赛道' },
];
